import { api } from '../lib/api';

export type SearchType = 'event' | 'wine' | 'member' | 'producer' | 'region';

export interface SearchHit {
  type: SearchType;
  id: string;
  title: string;
  subtitle: string | null;
  year: number | null;
  score: number;
  href: string;
}

export interface SearchResults {
  results: SearchHit[];
  counts: Partial<Record<SearchType, number>>;
}

export const searchApi = {
  search: (q: string) =>
    api
      .get<{ data: SearchResults }>(`/search?q=${encodeURIComponent(q)}`)
      .then((r) => r.data),
};
